import { AbstractControl, ValidatorFn } from '@angular/forms';

export const nanValidator: ValidatorFn = (control: AbstractControl) => {
  return Number.isNaN(control.getRawValue()) ? { 'NaN': true } : null;
};